// router
import router from '@/router';

const { isAdd } = router.currentRoute.meta;

/**
 *
 * Função que verifica no paylaod os valores relacionados
 * com a criação de detalhes de um pedido de contacto e
 * adiciona os campos ao objeto principal para enviar apra
 * a API.
 *
 * @param {String}  payloadKey
 * @param {String}  apiKey
 * @param {Object}  payloadData
 * @param {Object}  apiObject
 *
*/
const buildDetailsFields = ({
    payloadKey,
    apiKey,
    payloadData,
    apiObject
}) => {
    const keys = Object.keys( payloadData ).filter( key => key.includes( `${payloadKey}-label-` ) );
    const keysSplit = keys.map( key => key.split( '-' )[2] );

    keysSplit.forEach( id => {
        apiObject[`${apiKey}[${payloadData[`${payloadKey}-label-${id}`]}]`] = payloadData[`${payloadKey}-value-${id}`] || '';
    });
};

/**
 *
 * Criação do objecto de alteração de contacto.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos no modal serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = data => {
    const {
        type,
        email,
        phone,
        primary
    } = data;

    const contact = {
        ...( data.campaignId && { campaign_id: data.campaignId }),
        ...( data.holder && { 'person[name]': data.holder }),
        ...( data.contactPerson && { 'person[contact_person]': data.contactPerson }),
        ...( data.birthdate && { 'person[birthdate]': data.birthdate }),
        ...( data.nationalIdentificationNumber && { 'person[national_identification_number]': data.nationalIdentificationNumber }),
        ...( data.taxpayerIdentificationNumber && { 'person[taxpayer_identification_number]': data.taxpayerIdentificationNumber }),
        ...( data.address && { 'person[addresses][0][address]': data.address }),
        ...( data.preferenceContact && { 'preference_contact[date]': data.preferenceContact }),
        ...( data.observations && { observations: data.observations }),
        ...( isAdd && {
            ...( phone && {
                'person[contacts][0][type]': 'phone',
                'person[contacts][0][value]': phone,
                'person[contacts][0][primary]': +true
            }),
            ...( email && {
                'person[contacts][1][type]': 'email',
                'person[contacts][1][value]': email,
                'person[contacts][1][primary]': +true
            })
        })
    };

    if ( isAdd ) {
        buildDetailsFields({
            payloadKey: 'detail',
            apiKey: 'data',
            payloadData: data,
            apiObject: contact
        });

        buildDetailsFields({
            payloadKey: 'optional',
            apiKey: 'optional',
            payloadData: data,
            apiObject: contact
        });
    }

    if ( !isAdd ) {
        contact['person[contacts][0][type]'] = type;
        contact['person[contacts][0][value]'] = ( type === 'phone' ) ? phone : email;
        contact['person[contacts][0][primary]'] = +primary;
    }

    return contact;
};

const requiredFields = [
    { field: 'holder', isRequiredOnEdit: false },
    { field: 'contactPerson', isRequiredOnEdit: false },
    { field: 'phone', isRequiredOnEdit: false },
    { field: 'preferenceContact', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};